export default __webpack_public_path__ + "static/media/loader.42e815ef.gif";